var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNewyearRefferal = function SvgNewyearRefferal(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 499,
    height: 180,
    viewBox: "0 0 499 180",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_734_12801)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 499,
    height: 180,
    rx: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_734_12801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435 20C435 22.2091 433.209 24 431 24C428.791 24 427 22.2091 427 20C427 17.7909 428.791 16 431 16C433.209 16 435 17.7909 435 20Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 32C435 34.2091 433.209 36 431 36C428.791 36 427 34.2091 427 32C427 29.7909 428.791 28 431 28C433.209 28 435 29.7909 435 32Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 44C435 46.2091 433.209 48 431 48C428.791 48 427 46.2091 427 44C427 41.7909 428.791 40 431 40C433.209 40 435 41.7909 435 44Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435 56C435 58.2091 433.209 60 431 60C428.791 60 427 58.2091 427 56C427 53.7909 428.791 52 431 52C433.209 52 435 53.7909 435 56Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 20C447 22.2091 445.209 24 443 24C440.791 24 439 22.2091 439 20C439 17.7909 440.791 16 443 16C445.209 16 447 17.7909 447 20Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 32C447 34.2091 445.209 36 443 36C440.791 36 439 34.2091 439 32C439 29.7909 440.791 28 443 28C445.209 28 447 29.7909 447 32Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 44C447 46.2091 445.209 48 443 48C440.791 48 439 46.2091 439 44C439 41.7909 440.791 40 443 40C445.209 40 447 41.7909 447 44Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447 56C447 58.2091 445.209 60 443 60C440.791 60 439 58.2091 439 56C439 53.7909 440.791 52 443 52C445.209 52 447 53.7909 447 56Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 20C459 22.2091 457.209 24 455 24C452.791 24 451 22.2091 451 20C451 17.7909 452.791 16 455 16C457.209 16 459 17.7909 459 20Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 32C459 34.2091 457.209 36 455 36C452.791 36 451 34.2091 451 32C451 29.7909 452.791 28 455 28C457.209 28 459 29.7909 459 32Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 44C459 46.2091 457.209 48 455 48C452.791 48 451 46.2091 451 44C451 41.7909 452.791 40 455 40C457.209 40 459 41.7909 459 44Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 56C459 58.2091 457.209 60 455 60C452.791 60 451 58.2091 451 56C451 53.7909 452.791 52 455 52C457.209 52 459 53.7909 459 56Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 20C471 22.2091 469.209 24 467 24C464.791 24 463 22.2091 463 20C463 17.7909 464.791 16 467 16C469.209 16 471 17.7909 471 20Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 32C471 34.2091 469.209 36 467 36C464.791 36 463 34.2091 463 32C463 29.7909 464.791 28 467 28C469.209 28 471 29.7909 471 32Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 44C471 46.2091 469.209 48 467 48C464.791 48 463 46.2091 463 44C463 41.7909 464.791 40 467 40C469.209 40 471 41.7909 471 44Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 56C471 58.2091 469.209 60 467 60C464.791 60 463 58.2091 463 56C463 53.7909 464.791 52 467 52C469.209 52 471 53.7909 471 56Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 20C483 22.2091 481.209 24 479 24C476.791 24 475 22.2091 475 20C475 17.7909 476.791 16 479 16C481.209 16 483 17.7909 483 20Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 32C483 34.2091 481.209 36 479 36C476.791 36 475 34.2091 475 32C475 29.7909 476.791 28 479 28C481.209 28 483 29.7909 483 32Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 44C483 46.2091 481.209 48 479 48C476.791 48 475 46.2091 475 44C475 41.7909 476.791 40 479 40C481.209 40 483 41.7909 483 44Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483 56C483 58.2091 481.209 60 479 60C476.791 60 475 58.2091 475 56C475 53.7909 476.791 52 479 52C481.209 52 483 53.7909 483 56Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M339.5 138.562C385.926 138.562 423.562 100.926 423.562 54.5C423.562 8.07357 385.926 -29.5625 339.5 -29.5625C293.074 -29.5625 255.438 8.07357 255.438 54.5C255.438 100.926 293.074 138.562 339.5 138.562ZM339.5 189C413.782 189 474 128.782 474 54.5C474 -19.7823 413.782 -80 339.5 -80C265.218 -80 205 -19.7823 205 54.5C205 128.782 265.218 189 339.5 189Z",
    fill: "#FFCC80",
    fillOpacity: 0.12
  })), /*#__PURE__*/React.createElement("path", {
    d: "M470 122.76L471.997 133.602L472.06 133.94L472.398 134.003L483.24 136L472.398 137.997L472.06 138.06L471.997 138.398L470 149.24L468.003 138.398L467.94 138.06L467.602 137.997L456.76 136L467.602 134.003L467.94 133.94L468.003 133.602L470 122.76Z",
    fill: "white",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_734_12801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 499,
    height: 180,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_734_12801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 499,
    height: 180,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewyearRefferal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/newyear_refferal.6efd3f3c.svg";
export { ForwardRef as ReactComponent };